import React, { useEffect, useState } from 'react'
import { Typography } from 'antd'

const REFRESH_INTERVAL_SECONDS = 15

type AmlCheckCountdownProps = {
  onFinish: () => void
}

export const AmlCheckCountdown: React.FC<AmlCheckCountdownProps> = ({
  onFinish,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(REFRESH_INTERVAL_SECONDS)

  useEffect(() => {
    if (secondsLeft === 0) {
      onFinish()
      return
    }

    const timeoutId = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000)

    return () => clearTimeout(timeoutId)
  }, [secondsLeft, onFinish])

  return (
    <Typography.Text type="secondary">
      Повторный запрос через {secondsLeft} сек.
    </Typography.Text>
  )
}
